import { useRoute, useRouter } from "vue-router";
import { ref, onMounted } from "vue";
import { prefillState } from "@/utils/prefillState";
import { useModal } from "@/components/UI/Modal/useModal";
import { DATES } from "@/components/UI/Modal/Bodies/OrderFilters/OrderFilters.consts";
import { PRETTY_PREVIEW_STATUSES, PRETTY_PREVIEW_AGENTS } from "@/consts/prettyPreviewValues";
import { STATUS_FILTER, AGENT_TYPE, ACTIVE_ONLY } from "./PreviewRequestsFilters.consts";

const getFilters = () => [
  { key: STATUS_FILTER, init: null, type: "array" },
  { key: AGENT_TYPE, init: null, type: "string" },
  { key: ACTIVE_ONLY, init: false, type: "boolean" },
  { key: DATES, init: null, type: "array" },
];

export const usePreviewRequestsFilters = () => {
  const route = useRoute();
  const router = useRouter();
  const formData = ref(prefillState(getFilters()));
  const { close } = useModal();
  const prettyPreviewStatusOptions = PRETTY_PREVIEW_STATUSES;
  const agentTypeOptions = PRETTY_PREVIEW_AGENTS;
  const loadFiltersFromUrl = () => {
    const query = route.query;
    let statusValue = null;
    if (query.status) {
      statusValue = Array.isArray(query.status) ? query.status : [query.status];
    }
    let dateValue = null;
    if (query.date_from || query.date_to) {
      const startDate = query.date_from ? new Date(query.date_from) : null;
      const endDate = query.date_to ? new Date(query.date_to) : null;
      dateValue = [startDate, endDate];
    }
    const savedFilters = {
      [STATUS_FILTER]: statusValue,
      [AGENT_TYPE]: query.agent_type || null,
      [ACTIVE_ONLY]: query.active_only === "1",
      [DATES]: dateValue,
    };
    formData.value = savedFilters;
  };

  const onSave = () => {
    const queryParams = {};
    if (route.query.search) {
      queryParams.search = route.query.search;
    }
    if (formData.value[STATUS_FILTER] && formData.value[STATUS_FILTER].length > 0) {
      queryParams.status = formData.value[STATUS_FILTER];
    }
    if (formData.value[AGENT_TYPE]) {
      queryParams.agent_type = formData.value[AGENT_TYPE];
    }
    if (formData.value[ACTIVE_ONLY]) {
      queryParams.active_only = "1";
    }
    if (formData.value[DATES] && formData.value[DATES].length === 2) {
      const [startDate, endDate] = formData.value[DATES];
      if (startDate) {
        queryParams.date_from = startDate.toISOString().split("T")[0];
      }
      if (endDate) {
        queryParams.date_to = endDate.toISOString().split("T")[0];
      }
    }
    router.push({ query: queryParams });
    close();
  };

  const onClear = () => {
    formData.value = {
      [STATUS_FILTER]: null,
      [AGENT_TYPE]: null,
      [ACTIVE_ONLY]: false,
      [DATES]: null,
    };
    const queryParams = {};
    if (route.query.search) {
      queryParams.search = route.query.search;
    }
    router.push({ query: queryParams });
    close();
  };

  onMounted(() => {
    if (
      Object.keys(route.query).length > 0 &&
      (route.query.status ||
        route.query.agent_type ||
        route.query.active_only ||
        route.query.date_from)
    ) {
      loadFiltersFromUrl();
    }
  });

  return {
    formData,
    prettyPreviewStatusOptions,
    agentTypeOptions,
    onSave,
    onClear,
  };
};
